import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['number', 'container'];

    connect() {
        this.animated = false;

        this.checkVisibility = this.checkVisibility.bind(this);
        window.addEventListener('scroll', this.checkVisibility);
        window.addEventListener('resize', this.checkVisibility);
        window.addEventListener('load', this.checkVisibility);
    }

    disconnect() {
        window.removeEventListener('scroll', this.checkVisibility);
        window.removeEventListener('resize', this.checkVisibility);
        window.removeEventListener('load', this.checkVisibility);
    }

    checkVisibility() {
        if (this.animated || !this.hasContainerTarget) return;

        const rect = this.containerTarget.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

        if (isVisible) {
            this.animateAllCounters();
            this.animated = true;
        }
    }

    animateAllCounters() {
        this.numberTargets.forEach(el => this.animateCounter(el));
    }

    animateCounter(el) {
        const dataVal = el.dataset.val.trim();

        const match = dataVal.match(/^([^\d\-]*)(-?\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(?:\.\d+)?)(.*)$/);

        if (!match) return;

        const before = match[1];
        const numberStr = match[2];
        const after = match[3];

        const number = parseFloat(numberStr.replace(/,/g, ''));
        if (isNaN(number)) return;

        el.textContent = before + '0' + after;

        const duration = 1500;
        let startTime = null;

        const step = (timestamp) => {
            if (!startTime) startTime = timestamp;

            const progress = Math.min((timestamp - startTime) / duration, 1);
            const currentValue = progress * number;

            const decimals = (numberStr.split('.')[1] || '').length;

            let displayValue = decimals > 0
                ? currentValue.toFixed(decimals)
                : Math.floor(currentValue).toString();

            if (numberStr.includes(',')) {
                displayValue = Number(displayValue).toLocaleString();
            }

            el.textContent = before + displayValue + after;

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        };

        requestAnimationFrame(step);
    }
}
